import React, { useEffect, useState, useCallback } from "react";
import api, { errMsg } from "@/lib/api";
import { toast } from "sonner";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { MessagesSquare, Send, Loader2 } from "lucide-react";

const fmt = (iso) => { if (!iso) return ""; try { return new Date(iso).toLocaleString([], { dateStyle: "short", timeStyle: "short" }); } catch { return iso; } };

export const PortalMessagesCard = ({ leadId }) => {
  const [items, setItems] = useState(null);
  const [text, setText] = useState("");
  const [sending, setSending] = useState(false);

  const load = useCallback(() => api.get(`/leads/${leadId}/portal-messages`).then(({ data }) => setItems(data.items)).catch(() => setItems([])), [leadId]);
  useEffect(() => { load(); }, [load]);

  const reply = async () => {
    const body = text.trim(); if (!body) return;
    setSending(true);
    try { await api.post(`/leads/${leadId}/portal-messages`, { body }); setText(""); toast.success("Reply sent to the family."); load(); }
    catch (e) { toast.error(errMsg(e, "Could not send reply.")); }
    finally { setSending(false); }
  };

  if (items === null) return null;

  return (
    <Card className="mt-4 p-4 border-[#E6EDF2]" data-testid="lead-portal-messages-card">
      <div className="text-[11px] font-bold uppercase tracking-wide text-[#1C4358]/70 mb-2 flex items-center gap-1.5"><MessagesSquare size={13} /> Portal messages ({items.length})</div>
      <div className="space-y-2 max-h-56 overflow-y-auto mb-2">
        {items.length === 0 ? <div className="text-[12px] text-[#9AA5B1]">No portal messages yet.</div> :
          items.map((m, i) => (
            <div key={i} className={`flex ${m.from === "staff" ? "justify-end" : "justify-start"}`}>
              <div className={`max-w-[80%] rounded-xl px-3 py-1.5 text-[13px] ${m.from === "staff" ? "bg-[#1C4358] text-white" : "bg-[#F1F5F8] text-[#252221]"}`}>
                <div className="whitespace-pre-line">{m.body}</div>
                <div className={`text-[10px] mt-0.5 ${m.from === "staff" ? "text-white/60" : "text-[#9AA5B1]"}`}>{m.from === "staff" ? "You" : (m.from_name || "Family")} · {fmt(m.at)}</div>
              </div>
            </div>
          ))}
      </div>
      <div className="flex gap-2">
        <Input value={text} onChange={(e) => setText(e.target.value)} onKeyDown={(e) => e.key === "Enter" && reply()} placeholder="Reply to the family…" className="h-9 text-[14px]" data-testid="portal-reply-input" />
        <Button size="sm" onClick={reply} disabled={sending} className="bg-[#9C1E22] hover:bg-[#861A1D] text-white gap-1" data-testid="portal-reply-btn">{sending ? <Loader2 size={14} className="animate-spin" /> : <Send size={14} />}</Button>
      </div>
    </Card>
  );
};
